export default __webpack_public_path__ + "static/media/sounds/troMicReadingCheck.mp3";